import { useGenUiConfig } from '../../shared/ui/config.js';
import type { FlightTariffPort } from '@voll-intelligence/genui-contract';

// Schema/tipos puros vivem em `tariff_view.ts` (backend-safe, re-exportados pelo
// barrel `index.ts`); aqui fica só o hook React. `react.tsx` importa
// `FlightTariffPort` daqui, então re-exportamos só esse tipo.
export type { FlightTariffPort } from '@voll-intelligence/genui-contract';

/**
 * Lê o port `flightTariff` do Context. `null` quando o host não o injeta
 * (preview/read-only) — o card então não mostra "Ver tarifas".
 */
export function useFlightTariffPort(): FlightTariffPort | null {
  return useGenUiConfig().ports?.flightTariff ?? null;
}
